/* eslint-disable react/no-danger */
import React, { useContext } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { ContactDetailsContext } from "../../context/contact-details-context";

// Components
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";

// Util
import getSolutionContent from "./util/getSolutionComponent";

// Styles
import styles from "./contact-us-delivery-solution.module.scss";

function ContactUsDeliverySolution({
  solution: { id, fields, buttonType, hierarchyPosition },
  className,
  contactMethods,
}) {
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  const locationOnPage = hierarchyPosition.join(" | ");

  const SolutionComponent = getSolutionContent(id);
  const newDesign = !buttonType;

  return (
    <article
      className={classnames(styles.deliverySolution, styles.deliverySolution__inner, className)}
      data-solution-id={id}
    >
      <div className={styles.deliverySolution__content}>
        <SolutionComponent />
      </div>
      {liveChatProminenceExperiment ? (
        <ContactDetailsBox
          title={"We're here to help"}
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
          viewContactDetails={!newDesign}
          directlyDisplayContactMethods
        />
      ) : (
        <ContactDetailsBox
          newDesign={newDesign}
          title={newDesign ? "Did this answer your question?" : "Still need help?"}
          leftButtonText={newDesign ? "No, I need help" : undefined}
          rightButtonText={newDesign ? "Yes, that‘s helpful" : undefined}
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          location={locationOnPage}
          contactMethods={contactMethods}
        />
      )}
    </article>
  );
}

ContactUsDeliverySolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.string),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
  contactMethods: PropTypes.shape({
    emailUs: PropTypes.arrayOf(PropTypes.string),
    liveChat: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, pct: PropTypes.number })]),
    ),
  }),
};

ContactUsDeliverySolution.defaultProps = {
  className: undefined,
  contactMethods: {},
};

export default ContactUsDeliverySolution;
